import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import renderHTML from 'react-render-html';
// import SearchBar from '../common/SearchBar';

import ProductsSiteSearch from './ProductsSiteSearch';
import CategoriesSiteSearch from './CategoriesSiteSearch';
// import SupportSiteSearch from './SupportSiteSearch';
import SearchNotFound from '../notFound/SearchNotFound';

class SiteSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			keyword: null,
			products: [],
			categories: [],
			moreInfo: null
		};
	}

	componentWillMount() {
		this.setState({
			products: this.props.products
		});
		this.setState({
			categories: this.props.categories
		});
		this.setState({
			moreInfo: this.props.moreInfo
		});
	}
	
	render() {
		let products;
		let categories;
		// let support;
		const keyword = this.props.keyword !== undefined ? this.props.keyword : this.state.keyword;

		if (keyword === '') {
			return (
				<section className="section section-search-results no-results">
					<div className="section-content row">
						<div className="col">
							<h1 className="section-title">Search</h1>
							<p>
								To search our safe products,
								please enter a search term above.
							</p>
						</div>
					</div>
				</section>
			);
		}

		if (!this.props.count || this.props.count < 1) {
			return <SearchNotFound keyword={ keyword } />;
		}

		if (this.state.products !== undefined && this.state.products.length > 0) {
			const product = this.state.products.map(
				(product,index) => <ProductsSiteSearch key={ index } product={ product } />
			);
			products = (
				<ul className="results-list">
					{ product }
				</ul>
			);
		}

		if (this.state.categories !== undefined && this.state.categories.length > 0) {
			const category = this.state.categories.map(
				(category,index) => <CategoriesSiteSearch key={ index } category={ category } />
			);
			categories = (
				<ul className="results-list">
					{ category }
				</ul>
			);
		}

		// if (this.state.moreInfo !== undefined && this.state.moreInfo !== null) {
		// 	const serviceSupport = <SupportSiteSearch moreInfo={ this.state.moreInfo } />;
		// 	support = (
		// 		<ul className="results-list">
		// 			{ serviceSupport }
		// 		</ul>
		// 	);
		// }

		return (
			<div className="search-results">
				<Helmet
					title={ renderHTML(`Search Results for "${keyword}" &#124; SentrySafe`) }
					meta={[
						{
							property: 'description',
							content: 'Use search to find information you need about our products.'
						}
					]}
				/>

				<section className="section section-search-results">
					<div className="row">
						<div className="col">
							{/*<div className="search-bar-container">
								<SearchBar />
							</div>*/}
							<h1 className="section-title">
								<b>{ this.props.count }</b> { this.props.count === 1 ? 'Result' : 'Results' } for &ldquo;{ keyword }&rdquo;
							</h1>
							{ products }
							{ categories }
							{/* support */}
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	token: ['token'],
	keyword: ['siteSearch', 'keyword'],
	count: ['siteSearch', 'totalCount'],
	products: ['siteSearch', 'products'],
	categories: ['siteSearch', 'categories'],
	moreInfo: ['siteSearch', 'moreInfo']
}, SiteSearch);


// WEBPACK FOOTER //
// ./src/pages/sitesearch/SiteSearch.js